import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: 'sm-add-wallet-money',
  templateUrl: './add-wallet-money.component.html',
  styleUrls: ['./add-wallet-money.component.scss']
})
export class AddWalletMoneyComponent implements OnInit, OnDestroy {
  amount: number = 0
  notes:any
  apisub: Subscription;
  constructor(
    private apiservice: ApiService,
    private activemodal: MatDialogRef<AddWalletMoneyComponent>,
    private ls: LoaderServiceService,
    @Inject(MAT_DIALOG_DATA) public parentdata:any
  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_TRANSACTION_TO_WALLET
      ) {
        if (resdata.result) {
          this.activemodal.close({amount: this.amount,errorcode:resdata.result.errorcode ,msg:'success'})
        }
      }
    });
  }
  notify: boolean = false;

  ngOnInit(): void {}

  onsave() {
    let data = {
      entity_hash: this.parentdata.entity_hash,
      phone: this.parentdata.phone,
      amount: this.amount,
      notes: this.notes,
      country_code: this.parentdata.country_code,
      transaction_date: this.formatDateString(),
      created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
       is_notify: this.notify === true ? 1 : 0,
      custom_message: this.cmsg,
      email: this.parentdata.me && this.parentdata.me != '' && this.parentdata.me != 'null' && this.parentdata.me != '---' ? this.parentdata.me : null,
    };
       Object.keys(data).forEach((key) => {
      if ((data as any)[key] === null) {
        delete (data as any)[key];
      }
    });

    this.ls.showLoader = true
    this.apiservice.addTransactionToWallet(data)
  }

  formatDateString(): string {
    const now = new Date();

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }
  cmsg: any;

  onNotifyChange(event: any) {
    let csym =
      typeof sessionStorage.getItem(
        SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
      ) == "string"
        ? JSON.parse(
            sessionStorage.getItem(
              SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
            )!
          )
        : sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
          );
    // Option A: Check the event directly

    // Option B: Since you have [(ngModel)], this.notify is already updated
    if (event.checked) {
      const numericAmount = Number(this.amount) || 0;
      this.cmsg =
        localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_NAME) +
        " added   " +
        csym.currencySymbol +
        numericAmount.toFixed(2) +
        " into your wallet.";
      // e.g., show a message or call another API
    } else {
      console.log("Triggering logic for unchecked...");
      // e.g., clear some data
      this.cmsg = null;
    }
  }

   onAmountChange(newValue: number) {
    let csym =
      typeof sessionStorage.getItem(
        SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
      ) == "string"
        ? JSON.parse(
            sessionStorage.getItem(
              SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
            )!
          )
        : sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
          );
    if (this.notify) {
            const numericAmount = Number(newValue) || 0;

      this.cmsg =
        localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_NAME) +
        " added " +
        csym.currencySymbol +
        numericAmount.toFixed(2) +
        " into your wallet.";
      // e.g., show a message or call another API
    } else {
      console.log("Triggering logic for unchecked...");
      // e.g., clear some data
      this.cmsg = null;
    }
  }
}
